import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contex/AuthContext.jsx";
import { Reviews_Route } from "../router/routes.js";

function Register() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [telegram, setTelegram] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const { register, user, isLoading } = useAuth();
    const navigate = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }
        try {
            await register({ name, email, password, telegram });
            navigate(Reviews_Route);
        } catch (err) {
            console.error(err);
            setError(err.message || "Registration failed");
        }
    };

    // Redirect to Reviews page after successful registration
    useEffect(() => {
    }, [user, navigate]);

    return (
        <div className="register-container">
            <h2>Sign Up</h2>
            {error && <p className="error">{error}</p>}
            <form onSubmit={onSubmit}>
                <label>Name</label>
                <input
                    type="text"
                    required
                    placeholder="Enter your name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />

                <label>Email</label>
                <input
                    type="email"
                    required
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

                <label>Telegram (optional)</label>
                <input
                    type="text"
                    placeholder="Enter your Telegram username"
                    value={telegram}
                    onChange={(e) => setTelegram(e.target.value)}
                />

                <label>Password</label>
                <input
                    type="password"
                    required
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />

                <label>Confirm Password</label>
                <input
                    type="password"
                    required
                    placeholder="Repeat your password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />

                <button type="submit">Register</button>
            </form>
            {isLoading && <p className="loading-text">Processing...</p>}
        </div>
    );
}

export default Register;
